import React from 'react'
import Settings_nav from './Settings_nav'
import Header from './Header'
import axios from 'axios'
import Swal from 'sweetalert2'
import ReactLoading from 'react-loading';
import config from "../../config"
import Footer from './Footer'
const Bank_details = () => {
    
    let userDetail = localStorage.getItem('ship_rocket_user');
    console.log("userDetail====", userDetail);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
    const[userstate , setUserState] = React.useState({})
    const[companystate , setcompanyState] = React.useState({})
    const [formData, setFormData] = React.useState({
        accountname: '',
        accountNumber: '',
        accountifsc: '',
        cancelchequeimage: null,
      
      });
      const [errors, setErrors] = React.useState({});
    const [btnstate, setbtnstate] = React.useState(false);
    
    
    
      const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({})
      };
    
      const handleFileChange = (e, type) => {
        setFormData({ ...formData, [type]: e.target.files[0] });
        setErrors({})
      };
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
    });
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        setbtnstate(true)
    let errors = {};
    let isValid = true;

    if (!formData.accountname) {
      errors.accountname = 'Account Name is required';
      isValid = false;
    }

    if (!formData.accountNumber) {
      errors.accountNumber = 'Account Number is required';
      isValid = false;
    }

    if (!formData.accountifsc) {
      errors.accountifsc = 'IFSC Code is required';
      isValid = false;
    }

    if (!formData.cancelchequeimage) {
      errors.cancelchequeimage = 'Cancel Cheque Image is required';
      isValid = false;
    }

    

    if (!isValid) {
      setErrors(errors);
      setbtnstate(false)

      return;
    }
        const data = new FormData();
        
        data.append('customer_id', userData.customer_id);

        data.append('accountname', formData.accountname);
        data.append('accountNumber', formData.accountNumber);
        data.append('accountifsc', formData.accountifsc);
        data.append('cancelchequeimage', formData.cancelchequeimage);
       
        for (let [key, value] of data.entries()) {
            console.log(key, value);
          }

        try {
            let full_api = config.apiUrl + `/user/add_customer_bank_details`;
            axios.post(full_api, data, { headers: config.headers }).then((res) => {
                if(res){
                    Toast.fire({
                        background:"#3659cd",
                        type: 'success',
                        title: res.data.message ,
                        color:"white"
                      });
                
                    user()
      setbtnstate(false)

                 }
                 else{
                    Toast.fire({
                        background:"#a61c09",
                        type: 'success',
                        title: "Something Went Wrong" ,
                        color:"white"
                      });
      setbtnstate(false)

                    }
            })
            // Handle success or redirect user
          } catch (error) {
            console.error('Error:', error);
      setbtnstate(false)

            // Handle error
          }
      }
      React.useEffect(()=>{
        user()
     },[])
    const user=()=>{
        let dataToSend = {
    };
   
      // console.log("datatoSend",dataToSend)
      let url = config.apiUrl + '/user/find_customer_bank_detail';
    //  console.log("headers =========> ", config.headers);
      axios.post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        console.log("res ===" , res.data.output)
        setUserState(res.data.customer)
        setcompanyState(res.data.company)
       
        setFormData({...formData ,accountname:res.data.output.account_name ,accountNumber:res.data.output.bankAccount , accountifsc:res.data.output.ifsc , cancelchequeimage:res.data.output.cancelchequeimage   })
        // console.log("response ===" , response)
        //   const obscuredAadhar = obscureAadharNumber(res.data.ouptut.aadhaar_number);
        // console.log("obscuredAadhar == " , obscuredAadhar)
        // setAadharNumber(obscuredAadhar);
      
          })
          .catch((error) => {
              console.log(error);
          });    
   }
  return (
    <div>
       <Header/>
 <div class="page-wrapper pinned">
  <div class="main-container">
   <div className='app-container'>
  <div class="app-body">
  <div class="container-fluid"> 
 
  <div class="mob_nav">
  <div class=" d-flex justify-content-start ">
    <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
    <h2>Bank Account Settings</h2>
  </div>
</div>


<div class="row justify-content-between">
    <div class="col-12 col-md-4 desk_nav">
      <div class="d-flex">
        <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
        <h2>Bank Account Settings</h2>
      </div>
    </div>
</div>
     
       
          
<div class="row">
    <div class="col-12 col-md-3 left_sub_menu_bx mb_display_none">
       <Settings_nav value={2}/>
    </div>
    <div class="col-12 col-md-9">
    <div>
                                {userstate.kyc==true?
                                <div class="alert alert-success">
                                    <strong>Verified!</strong> Your Bank details has been verified already.
                                </div>:
                                <div class="alert alert-warning">
                                    <strong>Pending!</strong> Your Bank details are under review. Our team will update you soon.
                                </div>
}
                            </div>
        <div class="card border-0 shadow-sm">
            <div class="card-body">
            <div class="row">
                    <div class="col-12 col-md-6 mb-3">
                        <label for="" class="form-label">Account Holder Name: <span class="text-danger">*</span></label>
                        <input type="email" class="form-control" id="email" placeholder="Enter Account Holder Name" name="accountname"
                        value={formData.accountname}
                        onChange={handleChange}/>
                           {errors.accountname && <div className="text-danger mt-2">{errors.accountname}</div>}
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <label for="" class="form-label">Account Number <span class="text-danger">*</span></label>
                      
                                        <input type="email" class="form-control" id="email" placeholder="Enter Account Number" name="accountNumber"
                        value={formData.accountNumber}
                        onChange={handleChange}/>
                          {errors.accountNumber && <div className="text-danger mt-2">{errors.accountNumber}</div>}
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <label for="" class="form-label">IFSC Code <span class="text-danger">*</span></label>
                        <input type="email" class="form-control" id="email" placeholder="Enter Branch IFSC Code" name="accountifsc"
                        value={formData.accountifsc}
                        onChange={handleChange}/>
                           {errors.accountifsc && <div className="text-danger mt-2">{errors.accountifsc}</div>}
                    </div>
                    {/* <div class="col-12 col-md-6 mb-3">
                        <label for="" class="form-label">Branch Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="text" placeholder="Branch Name"/>
                    </div> */}
                    {/* <div class="col-12 col-md-6 mb-3">
                        <label for="" class="form-label">Account Type <span class="text-danger">*</span></label>
                        <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"/>
                            <label class="form-check-label" for="inlineRadio1">Saving</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"/>
                            <label class="form-check-label" for="inlineRadio2">Current</label>
                        </div>
                        </div>
                    </div> */}
                    <div class="col-12 col-md-6 mb-3">
                        <label for="" class="form-label">Upload Cancel Cheque Copy <span class="text-danger">*</span></label>
                        <img src={formData.cancelchequeimage} class="img-fluid img-thumbnail" />
                        <input   className='form-control'
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            onChange={(e) => handleFileChange(e, 'cancelchequeimage')}/>
                             {errors.cancelchequeimage && <div className="text-danger mt-2">{errors.cancelchequeimage}</div>}
                        
                    </div>
            </div>

          
            {userstate.kyc==true?"":
                        <div class="py-3">
                             {btnstate==true?<div className='' style={{marginLeft:"60px"}}><ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={30}/></div>:<a onClick={(e)=>handleSubmit(e)} class="btn btn-primary">Update</a>}
                        </div>
}
            </div>
        </div>
    </div>
</div>
    
    </div></div>
    <Footer/></div></div></div>
    </div>
  )
}

export default Bank_details
